export default __webpack_public_path__ + "static/media/dummy.6b4a838d.png";